var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o);
} return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); });
} return e; }
import { FilterFunnel } from "../../../../builderPackage/assets/svg";
import { DynamicFormBuilderContainer } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.container";
import { FormItemTypes } from "../../../../builderPackage/components/dynamicFormBuilder/formBuilder/dynamicFormBuilder.entity";
import { MoreVert, Search } from "@mui/icons-material";
import { showSurface } from "../../../../redux/awaitedSurfacesSlice";
import { useAppDispatch, useAppSelector } from "../../../../store/hooks";
import { useMediaQuery, Typography, Chip, Box } from "@mui/material";
import FFRCatalogueComponent from "./FFRCatalogComponent";
import { FFRCountApi } from "../../services/apiCalls";
import { AreaFieldReportsKeys } from "../../services/entity";
import FFRFilterComponent from "./FFRFilterComponent";
import { RowSelectionPopup } from "./FFRRowSelectionPopup";
import { getUpdateKey } from "../../../../builderPackage/common/commonFunctions";
import { setReducerState } from "../../../../redux/crudSlice";
import { useState } from "react";
import ActionMenuList from "../../../../builderPackage/components/actionsMenuList";
import { DesktopTabComponent } from "../../../../components/molecules/desktopTabComponent";
import { showNotification } from "../../../../redux/commonSlice";
export var FFRCatalog = function () {
    var dispatch = useAppDispatch();
    var lgMode = useMediaQuery(function (theme) { return theme.breakpoints.up("sm"); });
    var crud = useAppSelector(function (state) { return state.crud; });
    var _a = useState([]), selectedRows = _a[0], setSelectedRows = _a[1];
    var fieldFailureReport = crud[AreaFieldReportsKeys.count];
    var handlePagingUpdate = function (state) {
        var updateKey = getUpdateKey(AreaFieldReportsKeys.FFRPaging + ((state === null || state === void 0 ? void 0 : state.SelectedButton) || "ReceivedToASM"));
        dispatch(setReducerState({
            key: updateKey,
            value: true
        }));
    };
    var ActionItem = function (id, rows, selectedButton) { return __awaiter(void 0, void 0, void 0, function () {
        var updatedRows, _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0:
                    if (!(rows.length < 1)) return [3 /*break*/, 2];
                    return [4 /*yield*/, dispatch(showNotification({
                            isOpen: true,
                            message: "Please select at least one Document!",
                            type: "error"
                        }))];
                case 1:
                    _d.sent();
                    return [2 /*return*/];
                case 2:
                    updatedRows = rows.map(function (row) { return _objectSpread(_objectSpread({}, row), {}, {
                        ActionTaken: id
                    }); });
                    setSelectedRows(updatedRows);
                    _a = id;
                    switch (_a) {
                        case "Resend To Dealer": return [3 /*break*/, 3];
                        case "Accept & group": return [3 /*break*/, 3];
                        case "Close FFR": return [3 /*break*/, 3];
                    }
                    return [3 /*break*/, 11];
                case 3:
                    if (!(rows.length < 1)) return [3 /*break*/, 5];
                    return [4 /*yield*/, dispatch(showNotification({
                            isOpen: true,
                            message: "Please select at-least one Document!",
                            type: "error"
                        }))];
                case 4:
                    _b = _d.sent();
                    return [3 /*break*/, 10];
                case 5:
                    if (!lgMode) return [3 /*break*/, 7];
                    return [4 /*yield*/, dispatch(showSurface({
                            type: "Dialog",
                            Component: RowSelectionPopup,
                            containerProps: {
                                fullWidth: true
                            },
                            componentProps: {
                                selectedRows: updatedRows
                            }
                        }))];
                case 6:
                    _c = _d.sent();
                    return [3 /*break*/, 9];
                case 7: return [4 /*yield*/, dispatch(showSurface({
                        type: "Drawer",
                        Component: RowSelectionPopup,
                        containerProps: {
                            anchor: 'bottom',
                            PaperProps: {
                                sx: {
                                    width: {
                                        xs: '100%',
                                        sm: '70%',
                                        md: '40%'
                                    },
                                    height: {
                                        xs: '80%',
                                        sm: '100%'
                                    },
                                    borderTopLeftRadius: 16,
                                    borderTopRightRadius: 16
                                }
                            }
                        },
                        componentProps: {
                            selectedRows: updatedRows
                        }
                    }))];
                case 8:
                    _c = _d.sent();
                    _d.label = 9;
                case 9:
                    _b = _c;
                    _d.label = 10;
                case 10:
                    _b;
                    return [3 /*break*/, 12];
                case 11:
                    console.warn("Unhandled action id:", id);
                    _d.label = 12;
                case 12: return [2 /*return*/];
            }
        });
    }); };
    var FFRsTab = [{
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            spacing: 0,
            columnGap: 1.5,
            alignItems: "center",
            py: 2.5,
            px: 3,
            elements: [{
                    type: FormItemTypes.Typography,
                    name: "",
                    fontSize: "xxl",
                    fontWeight: "strong",
                    children: "FFRs",
                    columnSize: 0
                }, {
                    type: FormItemTypes.Chip,
                    name: "all",
                    label: (fieldFailureReport === null || fieldFailureReport === void 0 ? void 0 : fieldFailureReport.received) + (fieldFailureReport === null || fieldFailureReport === void 0 ? void 0 : fieldFailureReport.reverted) + (fieldFailureReport === null || fieldFailureReport === void 0 ? void 0 : fieldFailureReport.isolated),
                    columnSize: 0,
                    color: "info",
                    setFormState: function () { return ({
                        SelectedButton: fieldFailureReport
                    }); },
                    sx: {
                        borderRadius: 1
                    }
                }, !lgMode ? {
                    type: FormItemTypes.ContainerItem,
                    name: "",
                    display: "flex",
                    columnSize: true,
                    justifyContent: "flex-end",
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "More",
                            children: /*#__PURE__*/ React.createElement(MoreVert, null),
                            size: "small",
                            variant: "text",
                            color: "secondary",
                            sx: {
                                p: "7px"
                            },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    sx: {
                                        p: "7px",
                                        display: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === "ResentByASM" ? "none" : "flex"
                                    }
                                };
                            },
                            columnSize: 0,
                            setFormState: function (state, e) { return __awaiter(void 0, void 0, void 0, function () {
                                var action;
                                return __generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, dispatch(showSurface({
                                                type: "Menu",
                                                containerProps: {
                                                    anchorEl: e.target.parentElement
                                                },
                                                Component: ActionMenuList,
                                                componentProps: {
                                                    items: [{
                                                            id: "Resend To Dealer",
                                                            children: "Resend to dealer",
                                                            disabled: (state === null || state === void 0 ? void 0 : state.SelectedButton) === "ResentByASM"
                                                        }, {
                                                            id: "Accept & group",
                                                            children: (state === null || state === void 0 ? void 0 : state.SelectedButton) === "Isolated" ? "Accept" : "Accept & group",
                                                            disabled: (state === null || state === void 0 ? void 0 : state.SelectedButton) === "ResentByASM"
                                                        }, {
                                                            id: "Close FFR",
                                                            children: "Close FFR",
                                                            disabled: (state === null || state === void 0 ? void 0 : state.SelectedButton) === "ResentByASM"
                                                        }]
                                                }
                                            }))];
                                        case 1:
                                            action = _a.sent();
                                            ActionItem(action.payload, selectedRows);
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }]
                } : null]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "",
            columnSize: 12,
            spacing: 0,
            columnGap: 1.5,
            alignItems: "center",
            py: 1,
            px: {
                xs: 2,
                sm: 3
            },
            borderTop: "1px solid",
            borderBottom: "1px solid",
            bgcolor: "secondary.100",
            borderColor: "secondary.200",
            elements: [{
                    type: FormItemTypes.TextInput,
                    name: "search",
                    placeholder: "Search",
                    columnSize: true,
                    InputProps: {
                        startAdornment: /*#__PURE__*/ React.createElement(Search, {
                            color: "secondary",
                            fontSize: "small"
                        })
                    },
                    sx: {
                        maxWidth: 320
                    }
                }, lgMode ? {
                    type: FormItemTypes.Button,
                    name: "ResendToDealer",
                    columnSize: 0,
                    onClick: function (e, formValues) { return ActionItem("Resend To Dealer", selectedRows, formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton); },
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: FormItemTypes.Button,
                            variant: "outlined",
                            fullWidth: true,
                            children: "Resend To Dealer",
                            sx: {
                                display: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) !== "ResentByASM" ? "inline-flex" : "none"
                            }
                        };
                    }
                } : null, lgMode ? {
                    type: FormItemTypes.Button,
                    name: "Accept&group",
                    columnSize: 0,
                    onClick: function (e, formValues) { return ActionItem("Accept & group", selectedRows, formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton); },
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: FormItemTypes.Button,
                            variant: "outlined",
                            fullWidth: true,
                            children: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === "Isolated" ? "Accept" : "Accept & group",
                            sx: {
                                display: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) !== "ResentByASM" ? "inline-flex" : "none"
                            }
                        };
                    }
                } : null, lgMode ? {
                    type: FormItemTypes.Button,
                    name: "CloseFFR",
                    columnSize: 0,
                    onClick: function (e, formValues) { return ActionItem("Close FFR", selectedRows, formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton); },
                    setFieldProps: function (formValues, currValue) {
                        return {
                            type: FormItemTypes.Button,
                            variant: "outlined",
                            fullWidth: true,
                            children: "Close FFR",
                            sx: {
                                display: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) !== "ResentByASM" ? "inline-flex" : "none"
                            }
                        };
                    }
                } : null, lgMode ? {
                    type: FormItemTypes.Divider,
                    name: "Divider",
                    orientation: "vertical",
                    columnSize: 0,
                    containerProps: {
                        height: "100%"
                    },
                    setFieldProps: function (formValues, currValue) {
                        return {
                            sx: {
                                display: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) !== "ResentByASM" ? "block" : "none"
                            }
                        };
                    }
                } : null, {
                    type: FormItemTypes.Button,
                    name: "filterButton",
                    startIcon: /*#__PURE__*/ React.createElement(FilterFunnel, null),
                    columnSize: 0,
                    variant: "outlined",
                    color: "secondary",
                    setFormState: function (state) { return __awaiter(void 0, void 0, void 0, function () {
                        var filters;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0: return [4 /*yield*/, dispatch(showSurface({
                                        type: "Drawer",
                                        Component: FFRFilterComponent,
                                        componentProps: {
                                            request: {
                                                FromDate: state.FromDate,
                                                ToDate: state.ToDate,
                                                DataRange: state.DataRange
                                            }
                                        },
                                        containerProps: {
                                            anchor: lgMode ? "right" : 'bottom',
                                            PaperProps: {
                                                sx: {
                                                    width: {
                                                        xs: '100%',
                                                        sm: '70%',
                                                        md: '40%'
                                                    },
                                                    height: {
                                                        xs: '80%',
                                                        sm: '100%'
                                                    },
                                                    borderTopLeftRadius: 16,
                                                    borderTopRightRadius: 16
                                                }
                                            }
                                        }
                                    }))];
                                case 1:
                                    filters = _a.sent();
                                    return [2 /*return*/, _objectSpread({}, filters.payload)];
                            }
                        });
                    }); },
                    children: lgMode ? "Filters" : ''
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "SelectedButton",
            value: 'ReceivedToASM',
            columnSize: 12,
            spacing: 0,
            columnGap: 1.5,
            alignItems: "center",
            py: 2.5,
            px: {
                xs: 2,
                sm: 3
            },
            elements: [{
                    type: FormItemTypes.CardComponent,
                    name: "",
                    columnSize: 0,
                    containerProps: {
                        maxWidth: '100%'
                    },
                    sx: {
                        bgcolor: "secondary.100",
                        p: 0.5,
                        overflow: 'auto',
                        scrollbarWidth: 'none'
                    },
                    contentProps: {
                        spacing: 0,
                        columnGap: 0.5,
                        flexWrap: 'nowrap'
                    },
                    elements: [{
                            type: FormItemTypes.Button,
                            name: "ReceivedToASM",
                            color: "secondary",
                            columnSize: 0,
                            setFormState: function () { return ({
                                SelectedButton: "ReceivedToASM"
                            }); },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: FormItemTypes.Button,
                                    sx: {
                                        color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'bold'
                                    }, " ", "Received"), /*#__PURE__*/ React.createElement(Chip, {
                                        label: fieldFailureReport === null || fieldFailureReport === void 0 ? void 0 : fieldFailureReport.received,
                                        size: "small",
                                        variant: "filled",
                                        color: "secondary",
                                        sx: {
                                            color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                            borderRadius: 6,
                                            px: 1,
                                            fontWeight: "bold",
                                            fontSize: 12
                                        }
                                    })),
                                    variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "ResentByASM",
                            color: "secondary",
                            columnSize: 0,
                            setFormState: function () { return ({
                                SelectedButton: "ResentByASM"
                            }); },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: FormItemTypes.Button,
                                    sx: {
                                        color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'bold'
                                    }, " ", "Reverted"), /*#__PURE__*/ React.createElement(Chip, {
                                        label: fieldFailureReport === null || fieldFailureReport === void 0 ? void 0 : fieldFailureReport.reverted,
                                        size: "small",
                                        variant: "filled",
                                        color: "secondary",
                                        sx: {
                                            color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                            borderRadius: 6,
                                            px: 1,
                                            fontWeight: "bold",
                                            fontSize: 12
                                        }
                                    })),
                                    variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                };
                            }
                        }, {
                            type: FormItemTypes.Button,
                            name: "Isolated",
                            color: "secondary",
                            columnSize: 0,
                            setFormState: function () { return ({
                                SelectedButton: "Isolated"
                            }); },
                            setFieldProps: function (formValues, currValue) {
                                return {
                                    type: FormItemTypes.Button,
                                    sx: {
                                        color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : ''
                                    },
                                    children: /*#__PURE__*/ React.createElement(Box, {
                                        display: "flex",
                                        gap: 1,
                                        justifyContent: "space-between",
                                        alignItems: "center"
                                    }, /*#__PURE__*/ React.createElement(Typography, {
                                        fontWeight: 'bold'
                                    }, " ", "Isolated"), /*#__PURE__*/ React.createElement(Chip, {
                                        label: fieldFailureReport === null || fieldFailureReport === void 0 ? void 0 : fieldFailureReport.isolated,
                                        size: "small",
                                        variant: "filled",
                                        color: "secondary",
                                        sx: {
                                            color: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? 'black' : '',
                                            borderRadius: 6,
                                            px: 1,
                                            fontWeight: "bold",
                                            fontSize: 12
                                        }
                                    })),
                                    variant: (formValues === null || formValues === void 0 ? void 0 : formValues.SelectedButton) === this.name ? "outlined" : "text"
                                };
                            }
                        }]
                }]
        }, {
            type: FormItemTypes.ContainerItem,
            name: "table",
            columnSize: 12,
            spacing: 0,
            elements: [{
                    type: FormItemTypes.Custom,
                    name: "catalog",
                    columnSize: 12,
                    element: function (props) { /*#__PURE__*/ return React.createElement(FFRCatalogueComponent, _extends({}, props, {
                        onSelectionChange: function (rows) { return setSelectedRows(rows); },
                        rowData: selectedRows
                    })); }
                }]
        }];
    return /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(DesktopTabComponent, null), /*#__PURE__*/ React.createElement(DynamicFormBuilderContainer, {
        formData: FFRsTab,
        getFormAPI: FFRCountApi,
        mode: "edit",
        getKey: AreaFieldReportsKeys.count,
        gridProps: {
            spacing: 0
        },
        onChange: function (e, _ref) {
            var state = _ref.state, field = _ref.field, value = _ref.value;
            if ((field === null || field === void 0 ? void 0 : field.name) == "ReceivedToASM" || (field === null || field === void 0 ? void 0 : field.name) == "ResentByASM" || (field === null || field === void 0 ? void 0 : field.name) == "Isolated" || (field === null || field === void 0 ? void 0 : field.name) == "filterButton")
                handlePagingUpdate(state);
        }
    }));
};
